var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import filters, { DEFAULT_PLACE, DEFAULT_PRICE, DEFAULT_ROOM, submitBtnText } from './lib/stores/filters';
import { writable } from 'svelte/store';
import App from './App.svelte';
const target = document.querySelector("#filter-form");
const filterData = JSON.parse(target.dataset.filters);
const activeId = writable();
const context = new Map();
// flatpickr is loaded via script
//@ts-ignore
(_a = window.flatpickr) === null || _a === void 0 ? void 0 : _a.localize(window.flatpickr.l10ns[target.dataset.locale]);
context.set('filter', filterData);
context.set('active-category', {
    activeId,
    transitionDuration: 400,
    setActiveId: (id) => activeId.set(id),
    closeActive: () => activeId.set(''),
});
submitBtnText.set(filterData.buttons.showResults);
filters.set({
    place: ((_b = filterData.categories.location) === null || _b === void 0 ? void 0 : _b.place.selected) || DEFAULT_PLACE,
    accommodationTypes: filterData.categories.type.accommodationTypes.checked || [],
    accommodationWith: filterData.categories.type.accommodationWith.checked || [],
    season: (_d = (_c = filterData.categories.price) === null || _c === void 0 ? void 0 : _c.season) === null || _d === void 0 ? void 0 : _d.selected.value,
    priceFrom: +((_e = filterData.categories.price) === null || _e === void 0 ? void 0 : _e.priceFrom.selected.value) || DEFAULT_PRICE,
    priceTo: +((_f = filterData.categories.price) === null || _f === void 0 ? void 0 : _f.priceTo.selected.value) || DEFAULT_PRICE,
    roomType: +((_g = filterData.categories.type.roomType) === null || _g === void 0 ? void 0 : _g.selected.value) || DEFAULT_ROOM,
    hory: (_h = filterData.categories.region) === null || _h === void 0 ? void 0 : _h.hory.checked,
    dateFrom: ((_j = filterData.categories.term) === null || _j === void 0 ? void 0 : _j.dateFrom) || '',
    dateTo: ((_k = filterData.categories.term) === null || _k === void 0 ? void 0 : _k.dateTo) || '',
});
const app = new App({ target, context, intro: true });
target.querySelector('#filter-skeleton').remove();
export default app;
